/* Aleefy 3D product look — cards depth + product turntable + real 3D models. */
(function () {
  'use strict';
  var d = document, w = window;
  function mq(q) { return w.matchMedia ? w.matchMedia(q).matches : false; }
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var fine = mq('(hover: hover) and (pointer: fine)');
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function safe(fn) { try { fn(); } catch (e) { if (w.console) console.warn('3d:', e); } }

  /* ---------- tilt + depth for collection cards (.prod is handled by motion.js) ---------- */
  safe(function () {
    if (!fine || reduce) return;
    $$('.txc').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        el.classList.add('p3-tilt');
        el.style.transform = 'perspective(900px) rotateX(' + (-y * 12).toFixed(2) + 'deg) rotateY(' + (x * 14).toFixed(2) + 'deg)';
        el.style.setProperty('--mx', ((x + 0.5) * 100).toFixed(1) + '%');
        el.style.setProperty('--my', ((y + 0.5) * 100).toFixed(1) + '%');
      });
      el.addEventListener('pointerleave', function () {
        el.classList.remove('p3-tilt');
        el.style.transform = '';
        el.style.setProperty('--mx', '50%'); el.style.setProperty('--my', '50%');
      });
    });
  });

  /* ---------- product page: 3D turntable stage ---------- */
  safe(function () {
    var wrap = $('[data-main-image-wrap]');
    if (!wrap || !$('img', wrap)) return;
    wrap.classList.add('p3d');
    var floor = d.createElement('span'); floor.className = 'p3d-floor'; floor.setAttribute('aria-hidden', 'true');
    var ring = d.createElement('span'); ring.className = 'p3d-ring'; ring.setAttribute('aria-hidden', 'true'); ring.innerHTML = '<i></i><i></i>';
    var shine = d.createElement('span'); shine.className = 'p3d-shine'; shine.setAttribute('aria-hidden', 'true');
    var badge = d.createElement('span'); badge.className = 'p3d-badge'; badge.setAttribute('aria-hidden', 'true');
    badge.innerHTML = '<b>↻</b>' + (fine ? 'Drag to rotate' : 'Swipe to rotate');
    wrap.insertBefore(ring, wrap.firstChild);
    wrap.insertBefore(floor, wrap.firstChild);
    wrap.appendChild(shine); wrap.appendChild(badge);

    var ang = 0, target = 0, dragging = false, sx = 0, base = 0, t0 = performance.now(), running = false, visible = true;
    function img() { return $('img', wrap); }
    function tick(now) {
      if (!running) return;
      var t = (now - t0) / 1000;
      if (!dragging) target = reduce ? 0 : Math.sin(t * 0.9) * 16;
      ang += (target - ang) * (dragging ? 0.35 : 0.06);
      var bob = reduce ? 0 : Math.sin(t * 1.8) * 1.6;
      var im = img();
      if (im) { im.style.rotate = 'y ' + ang.toFixed(2) + 'deg'; im.style.translate = '0 ' + (-bob - 1.5).toFixed(2) + '%'; }
      floor.style.setProperty('--sh', (1 - bob * 0.04).toFixed(3));
      requestAnimationFrame(tick);
    }
    function setRun(on) { if (on && !running) { running = true; requestAnimationFrame(tick); } else if (!on) running = false; }

    wrap.addEventListener('pointerdown', function (e) {
      if (e.button && e.button !== 0) return;
      dragging = true; sx = e.clientX; base = ang;
      wrap.classList.add('is-drag', 'was-dragged'); wrap.classList.remove('pro-zoom');
      try { wrap.setPointerCapture(e.pointerId); } catch (err) {}
    });
    wrap.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      target = Math.max(-40, Math.min(40, base + (e.clientX - sx) * 0.35));
      wrap.classList.remove('pro-zoom');
    });
    function end() { dragging = false; wrap.classList.remove('is-drag'); }
    wrap.addEventListener('pointerup', end);
    wrap.addEventListener('pointercancel', end);

    if ('IntersectionObserver' in w) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; setRun(visible && !d.hidden); }).observe(wrap);
    d.addEventListener('visibilitychange', function () { setRun(visible && !d.hidden); });
    setRun(true);
  });

  /* ---------- real 3D models uploaded in Shopify ---------- */
  safe(function () {
    var box = $('[data-p3d-model]'), btn = $('[data-p3d-toggle]');
    if (!box || !btn) return;
    var wrap = $('[data-main-image-wrap]'), thumbs = $('.thumbs'), loaded = false;
    var label = btn.innerHTML;
    btn.addEventListener('click', function () {
      var on = box.hasAttribute('hidden');
      if (on) {
        box.removeAttribute('hidden');
        if (wrap) wrap.setAttribute('hidden', '');
        if (thumbs) thumbs.setAttribute('hidden', '');
        btn.classList.add('is-on');
        btn.innerHTML = '🖼️ ' + (btn.getAttribute('data-back') || 'Back to photos');
        if (!loaded && w.Shopify && Shopify.loadFeatures) {
          loaded = true;
          Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: function (err) {
            if (err) return;
            var mv = $('model-viewer', box);
            if (mv && Shopify.ModelViewerUI) { var ui = new Shopify.ModelViewerUI(mv); if (ui && ui.play) ui.play(); }
          } }]);
        }
      } else {
        box.setAttribute('hidden', '');
        if (wrap) wrap.removeAttribute('hidden');
        if (thumbs) thumbs.removeAttribute('hidden');
        btn.classList.remove('is-on');
        btn.innerHTML = label;
      }
    });
  });
})();
